export const experienceData = [
    {
        title: "Software Engineer I (Contract)",
        company: "Toshiba Global Commerce Solutions",
        location: "Durham, NC",
        period: "May 2026 – Present",
        link: "https://commerce.toshiba.com/",
        description: [
            "Mobile and web development on Toshiba's enterprise POS platform, contributing across the Android and web codebases for major retail customers",
            "Pairing with Claude and Codex day-to-day to ship faster while drawing on years of writing code by hand",
            "Stack: Flutter, Kotlin, Vue, MongoDB, Docker"
        ]
    },
    {
        title: "Developer",
        company: "Valuable",
        location: "Raleigh, NC",
        period: "Jan 2026 – May 2026",
        link: "https://www.valuable.app/",
        description: [
            "Expanded platform reach by building native iOS (Swift) and Android (Kotlin) apps from scratch, delivering full feature parity with the web platform and shipping new features post-launch",
            "Engineered AI-powered development workflows leveraging Claude's agentic tools for accelerated feature delivery",
            "Led a comprehensive redesign and rebuild of the web application, shipping 100% of the new build and modernizing the UI/UX",
            "Built Shopify integration enabling users to connect existing Shopify stores and push valued assets directly as inventory",
            "Built end-to-end test suites with XCTest (iOS) and JUnit/Espresso (Android), reducing test execution time by 60% while covering critical user flows from authentication to asset management"
        ]
    },
    {
        title: "Frontend Web Developer (Contract)",
        company: "Valuable",
        location: "Raleigh, NC",
        period: "May 2025 – Jan 2026",
        link: "https://www.valuable.app/",
        description: [
            "Sole front-end developer of a web app automating identification and valuation of collectibles and high-value assets, scaling to 1M+ items",
            "Spearheaded adoption of feature-sliced architecture across the React/TypeScript/Vite codebase, establishing the scalability foundation for 1M+ items",
            "Implemented real-time sync with Firestore listeners for asset details and user permissions",
            "Integrated with serverless backend on GCP using event-driven Cloud Functions",
            "Integrated Stripe to power a token-based payment system, driving 100K+ token purchases within the first 4 months post-launch",
            "Built multi-tenant CDN integration allowing users to connect their own CDN accounts and direct-upload asset media",
            "Developed EstateSales.net integration enabling direct publishing of asset records as live listings from the mobile app",
            "Established comprehensive testing infrastructure with Vitest, Playwright, and Firebase Emulator, enforced through CI/CD with Husky and GitHub Actions"
        ]
    },
    {
        title: "Freelance Software Engineer",
        company: "Independent Contractor",
        location: "Raleigh, NC",
        period: "Jan 2024 – May 2025",
        description: [
            "Designed and launched a digital product site selling exercise plan PDFs, with SEO-optimized landing pages and blog articles driving organic traffic, integrated with Stripe checkout"
        ]
    }
];
